import { UserNavigation } from '~/shell/components/UserNavigation';
import { TemplateNavigation } from '~/shell/components/TemplateNavigation';
import { CartButton } from '~/shell/components/CartButton';
import { useBasePath } from '~/common/hooks/useBasePath';
import type { IWebshopLoginInfoDtoData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';

export interface MobileHeaderNavigationProps {
  loginInfo?: IWebshopLoginInfoDtoData | null;
  isOciSession?: boolean;
}

export function MobileHeaderNavigation({ loginInfo, isOciSession }: Readonly<MobileHeaderNavigationProps>) {
  const { isBgh } = useBasePath();
  return (
    <div className={'flex gap-2'}>
      <TemplateNavigation loginInfo={loginInfo} />
      <UserNavigation loginInfo={loginInfo} isOciSession={isOciSession} />
      {isBgh && <CartButton />}
    </div>
  );
}
